module.exports = __webpack_public_path__ + "static/media/jetpacktocat.b9f0a08b.png";